import { validateEnumTranslations } from '../../safety_checks';

/**
 * Changement d'adresse email vérifié (table `email_change_request`).
 *
 * ⚠️IMPACT enums dual-defined : toute modification doit être reportée dans `schema.prisma`
 * (EmailChangeKind / EmailChangeStatus) ET dans une migration, même ordre de valeurs.
 */

/** Quelle adresse change. */
export enum EmailChangeKind {
  /** `professional.email_contact` : factures, notifications au pro, email affiché sur le site. */
  CONTACT = 'CONTACT',
  /** `account.email` : identifiant de connexion, destinataire du « mot de passe oublié ». */
  LOGIN = 'LOGIN',
  /**
   * `account.recovery_email` : adresse EXTERNE qui reçoit le « mot de passe oublié » quand l'email
   * de connexion est une boîte hébergée chez nous (la boîte seule ne doit pas ouvrir le compte).
   */
  RECOVERY = 'RECOVERY',
}

export enum EmailChangeStatus {
  /** En attente du clic de confirmation depuis la nouvelle adresse. */
  PENDING = 'PENDING',
  CONFIRMED = 'CONFIRMED',
  /** Annulée par le demandeur, le titulaire, ou depuis le lien envoyé à l'ancienne adresse. */
  CANCELLED = 'CANCELLED',
  /** Remplacée par une demande plus récente sur la même cible. */
  SUPERSEDED = 'SUPERSEDED',
}

export const TRANSLATE_KEY_EMAIL_CHANGE_KIND = 'EMAIL_CHANGE_KIND_';
export const TRANSLATE_KEY_EMAIL_CHANGE_STATUS = 'EMAIL_CHANGE_STATUS_';

export const EmailChangeKindTranslation = {
  'fr-FR': {
    [`${TRANSLATE_KEY_EMAIL_CHANGE_KIND}${EmailChangeKind.CONTACT}`]: "Email de contact de l'établissement",
    [`${TRANSLATE_KEY_EMAIL_CHANGE_KIND}${EmailChangeKind.LOGIN}`]: 'Email de connexion',
    [`${TRANSLATE_KEY_EMAIL_CHANGE_KIND}${EmailChangeKind.RECOVERY}`]: 'Adresse de récupération',
  },
};

export const EmailChangeStatusTranslation = {
  'fr-FR': {
    [`${TRANSLATE_KEY_EMAIL_CHANGE_STATUS}${EmailChangeStatus.PENDING}`]: 'En attente de confirmation',
    [`${TRANSLATE_KEY_EMAIL_CHANGE_STATUS}${EmailChangeStatus.CONFIRMED}`]: 'Confirmé',
    [`${TRANSLATE_KEY_EMAIL_CHANGE_STATUS}${EmailChangeStatus.CANCELLED}`]: 'Annulé',
    [`${TRANSLATE_KEY_EMAIL_CHANGE_STATUS}${EmailChangeStatus.SUPERSEDED}`]: 'Remplacé par une demande plus récente',
  },
};

//DONT TOUCH below this line
validateEnumTranslations(EmailChangeKind, EmailChangeKindTranslation, TRANSLATE_KEY_EMAIL_CHANGE_KIND, true);
validateEnumTranslations(EmailChangeStatus, EmailChangeStatusTranslation, TRANSLATE_KEY_EMAIL_CHANGE_STATUS, true);
